<template>
  <div class="stores">
    <div>
      <a target="_blank" @click.prevent="goToStore(spreadAppStoreLinks.ios)">
        <img src="/images/appstore.png" />
      </a>
    </div>
    <div>
      <a
        target="_blank"
        @click.prevent="goToStore(spreadAppStoreLinks.android)"
      >
        <img src="/images/googleplay.png" />
      </a>
    </div>
  </div>
</template>

<script>
import spreadAppStoreLinks from 'commons/spreadAppStoreLinks';
import dialogService from 'commons/dialogs/wrapper/dialogService';
import SpreadAppStoreDialog from 'src/app/components/connectDeviceDialog/SpreadAppStoreDialog.vue';

export default {
  name: 'SpreadAppStores',
  data() {
    return {
      spreadAppStoreLinks,
    };
  },
  methods: {
    goToStore(config) {
      dialogService.openDialog(SpreadAppStoreDialog, config);
    },
  },
};
</script>

<style lang="scss" scoped>
.stores {
  display: flex;

  & > div:first-child {
    margin-right: 16px;
  }

  img {
    height: 40px;
  }
}
</style>
